import { createRouter, createWebHistory } from "vue-router";
import store from "@/store/index";
import util from "@/util/util";

import axios from "@/util/axios";
import { defineAsyncComponent } from "vue";
import { h } from "vue";
import routeConfig from "./routeConfig";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

// 3. 创建路由实例并传递 `routes` 配置
// 你可以在这里输入更多的配置，但我们在这里
// 暂时保持简单
const router = createRouter({
  // 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
  history: createWebHistory(),
  routes: routeConfig.getRoutes(), // `routes: routes` 的缩写
  scrollBehavior(to, from, savedPosition) {
    // console.log("savedPosition",savedPosition)
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

NProgress.configure({
  easing: "ease", // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: false, // 是否显示加载 icon
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3, // 初始化时的最小百分比
});

// 导航守卫
router.beforeEach((to, from, next) => {
  NProgress.start();
  let app = document.getElementById("app");
  if (app) {
    app.style.zoom = localStorage.getItem("fontSize");
  }
  store.commit("setFrom", from);
  let nprogress = null;
  nprogress = document.getElementById("nprogress");
  if (nprogress) {
    nprogress.style.zoom = localStorage.getItem("fontSize");
  }
  let path = to.path;
  // console.log("",to,path,path == "/home",store.state,store.state.user);
  if (to.query.title) {
    store.commit("setTitle", to.query.title);
  } else if (to.meta.title) {
    store.commit("setTitle", to.meta.title);
  }
  // else if (path == "/home") {
  //   if (store.state.user) {
  //     let user = store.state.user;
  //     store.commit("setTitle", user.currOrg?.$label);
  //   }
  // }
  else {
    store.commit("setTitle", "");
  }

  let middleware = async () => {
    if (!store.state.imageServer) {
      let imageServer = await axios.get("/sys/imageServer");
      store.commit("setImageServer", imageServer);
    }

    let isLogin = store.getters.isLogin;
    if (isLogin) {
      let user = store.state.user;
      if (!user) {
        await store.dispatch("getCurrAccount");
        // try{
        //   let user=await axios.get("/account/curr");
        //   if(user){
        //     store.commit("setUser",user)
        //   }else{
        //     store.commit('logout')
        //   }
        // }catch(e){
        //   util.error(e)
        //   store.commit('logout')
        // }
      }
    } else {
      if (!path.startsWith("/login")) {
        console.log("未登录",to.fullPath)
        // util.error("请先登录");
        next("/login?redirect=" + to.fullPath); //增加跳转
      }
    }
  };

  middleware().then(() => {
    next();
  });
});

router.afterEach(() => {
  NProgress.done(); // 进度条结束
});

router.onError((error) => {
  NProgress.done();
  util.error("路由错误:" + error.message);
  window.location.reload(true);
});

export default router;
